import React, { useState, useEffect } from 'react';

import Box from '../Box';
import { Wrapper } from "./ACommonStyles";
import { getPcsUrls } from "./AHelpers";
import Link from "../../Link";
import { styled, globalCss } from '../../../stitches.config';
//customowy font
import FuturaMediumFont from "../../../assets/fonts/futura_medium-webfont.woff"
//logo
import logo from '../../../assets/img/samsung_logo.svg';
import bgdesktop from '../../../assets/img/samsung_desktop.jpg';
// import bgdesktopfinal from '../../../assets/img/samsung_desktop_final.png';
import bgmobile from '../../../assets/img/samsung_mobile.jpg';
// import bgmobilefinal from '../../../assets/img/samsung_mobile_final.png';

// aktualne zdjęcia
import bgdesktopfinal from "../../../assets/SpecialCampaigns/samsung/samsung_phone_desktop.jpg"
import bgmobilefinal from "../../../assets/SpecialCampaigns/samsung/samsung_phone_mobile.jpg"

import { pushDataLayer } from "../../../helpers";

export default props => {

  //daty prawidłowe
  const showTime = Date.parse('2022-02-08T12:00:00');
  const revealTime = Date.parse('2022-02-09T16:00:00');
  const endTime = Date.parse('2022-02-09T23:59:59');


  //daty na testy
  // const showTime = Date.parse('2022-02-04T12:00:00');
  // const revealTime = Date.parse('2022-02-08T16:00:00');
  // const endTime = Date.parse('2022-02-09T23:59:59');

  const [days, setDays] = React.useState(0);
  const [hours, setHours] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);
  const [seconds, setSeconds] = React.useState(0);
  const [promoHidden, setPromoHidden] = React.useState(true);
  const [reveal, setReveal] = React.useState(false);

  const calculateTime = (showTime, revealTime, endTime) => {
    const dateNow = Date.now();
    const time = revealTime - Date.now();
    if (dateNow < showTime || dateNow > endTime) {
      console.log("warunek 1");
      setDays(0)
      setHours(0)
      setMinutes(0)
      setSeconds(0)
      setPromoHidden(true);
    } else if (dateNow > showTime && dateNow < revealTime) {
      console.log("warunek 2");
      setPromoHidden(false);
      setDays(Math.floor(time / (1000 * 60 * 60 * 24)))
      setHours(Math.floor((time / (1000 * 60 * 60)) % 24))
      setMinutes(Math.floor((time / 1000 / 60) % 60))
      setSeconds(Math.floor((time / 1000) % 60))
    } else {
      console.log("warunek 3");
      setPromoHidden(false);
      setReveal(true);
    }
  }

  useEffect(() => {
    pushDataLayer({
      'event': 'analyticsEvent',
      'eventCategory': 'Special Campaigns',
      'eventAction': 'Samsung Galaxy',
      'eventLabel': window.location.pathname,
      'eventValue': undefined
    })
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      calculateTime(showTime, revealTime, endTime);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const leadingNumber = (value) => value < 10 ? "0" + value : value;

  if (!promoHidden)
    globalCss({
      "@font-face": {
        fontFamily: "Futura Medium",
        src: `url("${FuturaMediumFont}")`
      }
    })

  return (
    <>
      {promoHidden ? (
        <>
        </>
      ) : (
        <StyledSection className="container">
          <>
            <img src="https://ad.doubleclick.net/ddm/trackimp/N1167397.2207304DISPLAY/B26991611.325015041;dc_trk_aid=517229337;dc_trk_cid=163688576;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=?" border="0" height="1" width="1" alt="Advertisement" />
            <Link to="https://pubads.g.doubleclick.net/gampad/clk?id=5915919263&iu=/129257696/natemat">
              {reveal ? (
                <StyledRevealWrapper>
                  <StyledSamsungLogo src={logo} />
                </StyledRevealWrapper>
              ) : (
                <StyledWrapper>
                  <StyledTopText>za</StyledTopText>
                  <StyledCountdown>
                    <div className="countdown__wrap"><span>{String(days)}</span><span>dni</span></div>
                    <div className="countdown__wrap"><span>:</span></div>
                    <div className="countdown__wrap"><span>{String(leadingNumber(hours))}</span><span>godzin</span></div>
                    <div className="countdown__wrap"><span>:</span></div>
                    <div className="countdown__wrap"><span>{String(leadingNumber(minutes))}</span><span>minut</span></div>
                  </StyledCountdown>
                  <StyledBottomText>zobaczysz co kryje mrok</StyledBottomText>
                </StyledWrapper>
              )}
            </Link>
          </>

        </StyledSection>
      )}
    </>
  );
}
const StyledSection = styled("section", {
  position: "relative",
  width: "100%",
  paddingTop: "165%",
  "@media (min-width:992px)": {
    paddingTop: "44%"
  }
});
const StyledWrapper = styled("div", {
  position: "absolute",
  inset: "0",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundImage: `url("${bgmobile}")`,
  "@media (min-width:992px)": {
    backgroundImage: `url("${bgdesktop}")`,
    maxWidth: "1170px",
    margin: "0 auto"
  }
});
const StyledRevealWrapper = styled("div", {
  position: "absolute",
  inset: "0",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundImage: `url("${bgmobilefinal}")`,
  "@media (min-width:992px)": {
    backgroundImage: `url("${bgdesktopfinal}")`,
    maxWidth: "1170px",
    margin: "0 auto"
  }
});

const StyledTopText = styled("div", {
  fontFamily: "Futura Medium",
  fontSize: "42px",
  color: "#DBDBDB",
  marginTop: "55px",
  marginBottom: "50px",
  "@media (min-width:992px)": {
    fontSize: "48px",
    marginTop: "30px",
    marginBottom: "0"
  }
});
const StyledBottomText = styled("div", {
  fontFamily: "Futura Medium",
  fontSize: "32px",
  color: "#DBDBDB",
  marginTop: "auto",
  marginBottom: "25px",
  "@media (min-width:992px)": {
    fontSize: "48px",
    marginBottom: "20px"
  }
});
const StyledSamsungLogo = styled("img", {
  position: "absolute",
  left: "42px",
  top: "38px",
  width: "152px",
  height: "auto",
  "@media (min-width:992px)": {
    left: "29px",
    top: "35px"
  }
});


const StyledCountdown = styled("div", {
  fontFamily: '"Arial Black", \'Arial Bold\', Gadget, "Arial-BoldMT", "Arial"',
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "center",
  "@media (min-width:992px)": {},
  "& > div": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "&:nth-of-type(odd)": {
      width: "80px"
    },
    "&:nth-of-type(even)": {
      width: "25px"
    },
    "@media (min-width:992px)": {
      "&:nth-of-type(odd)": {
        width: "200px"
      },
      "&:nth-of-type(even)": {
        width: "55px"
      }
    },
    "& > span": {
      color: "white",
      fontSize: "12px",
      "@media (min-width:992px)": {
        fontSize: "16px"
      }
    },
    "& > span:first-of-type": {
      fontWeight: "bold",
      color: "#DBDBDB",
      fontSize: "48px",
      lineHeight: "48px",
      "@media (min-width:992px)": {
        fontSize: "122px",
        lineHeight: "122px"
      }
    },
    "&:nth-of-type(odd) > span:last-of-type": {
      fontFamily: '"Futura Medium"',
      fontSize: "20px",
      lineHeight: "40px",
      "@media (min-width:992px)": {
        fontSize: "24px",
        lineHeight: "24px"
      }
    }
  },
  "& >span": {
    color: "white",
    fontSize: "40px"
  }
});